module.exports = __webpack_public_path__ + "img/3-about.5ab752da.jpg";